<template>
    <div v-if="!loading" class="pb-2">
        <b-card class="mb-2">
            <div class="d-flex align-items-center">
                <div @click="$router.push('/tickets')" class="border-right pr-1 pointer">
                    <div class="text-center mb-50">
                        <feather-icon icon="ArrowRightIcon" size="26" />
                    </div>
                    <div style="font-size: 13px;">بازگشت</div>
                </div>
                <div class="px-1">
                    <h5 class="font-weight-bolder mb-50">{{ details.subject }}</h5>
                    <h5 class="mb-0" v-if="details.id">شناسه : {{ details.id }}</h5>
                </div>
            </div>
        </b-card>

        <div class="d-flex justify-content-md-end justify-content-center mb-2">
            <b-button @click="$bvModal.show('create-ticket-id')" class="px-2" variant="primary">
                ارسال پاسخ
            </b-button>
            <b-button @click="closeTicket" class="px-2 ml-1" variant="secondary">
                بستن تیکت
            </b-button>
        </div>

        <b-card no-body v-for="(item, index) in details.replies" :key="index">
            <div class="px-2 py-1 rounded-top" style="background-color: #afafaf1c;">
                <b-media no-body>
                    <b-media-aside>
                        <b-avatar size="50" :variant="item.fromSupport ? 'success' : 'info'">
                            <feather-icon size="24  " :icon="item.fromSupport ? 'HeadphonesIcon' : 'UserIcon'" />
                        </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                        <h4 class="mb-25">
                            {{ item.fromSupport ? 'پشتیبانی منوتِک' : details.storeName }}
                        </h4>
                        <b-card-text class="text-muted mb-0">
                            <span>
                                {{ new Date(item.createdAt).toLocaleTimeString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                        </b-card-text>
                    </b-media-body>
                </b-media>
            </div>
            <hr class="my-0">
            <div class="p-2">
                <p class="m-0 text-justify px-1">
                    {{ item.text }}
                </p>
                <div v-if="item.attachmentFile" class="mt-2">
                    <b-badge :href="BASE_URL_File + item.attachmentFile" pill target="_blank" variant="light-primary">
                        <feather-icon icon="LinkIcon" class="mr-25" />
                        <span>تصویر پیوست</span>
                    </b-badge>
                </div>
            </div>
        </b-card>


        <!------------------------------- modal create ticket ------------------------------->
        <b-modal id="create-ticket-id" title="پیام جدید" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <b-card-text class="p-1">
                <validation-observer #default="{ invalid }">
                    <b-form @submit.prevent>
                        <div>
                            <div>
                                <validation-provider #default="{ errors }" name="متن پیام" rules="required">
                                    <b-form-textarea v-model="form.text" placeholder="متن پیام" dir="rtl"
                                        class="text-primary-middle" :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center my-3">
                            <div style="width: 250px;height: 250px;">
                                <div @click="selectFile" :class="{ 'upload-file': !imageBlob }"
                                    class="pointer d-flex justify-content-center align-items-center">
                                    <input @change.prevent="createFile" ref="fileInput"
                                        accept="image/png, image/jpeg, image/webp" type="file" hidden />
                                    <div v-if="!imageBlob">
                                        <feather-icon size="95" icon="UploadCloudIcon" color="#7367f0f0" />
                                        <h5 class="text-primary mb-0 mt-1">پیوست تصویر</h5>
                                    </div>
                                    <div v-if="imageBlob" class="ticket-img">
                                        <b-img :src="imageBlob" class="object-fit-cover w-100 h-100"
                                            style="border-radius: 18px;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center pt-1">
                            <b-button @click="$bvModal.hide('create-ticket-id')" class="w-50 mr-1" variant="secondary">
                                انصراف
                            </b-button>
                            <b-button @click="replyTicket" class="d-flex align-items-center justify-content-center w-50"
                                variant="primary" :disabled="invalid || loadingButton">
                                <span>ارسال پیام</span>
                                <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
            </b-card-text>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BCardText, BMedia, BRow, BCol, BButton, BFormInput, BFormRadio, BBadge, BAvatar, BMediaAside, BMediaBody, BForm, BFormTextarea, BSpinner, BImg } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { storeService } from '@core/services';
import Compressor from 'compressorjs';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BMedia,
        BRow,
        BCol,
        BButton,
        BFormInput,
        BFormRadio,
        BBadge,
        BAvatar,
        BMediaAside,
        BMediaBody,
        BForm,
        BFormTextarea,
        BSpinner,
        BImg
    },
    data() {
        return {
            required,
            imageBlob: null,
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            loading: true,
            ticketId: null,
            storeId: null,
            details: {},
            form: {
                text: null,
                attachmentFile: null,
            },
            loadingButton: false,
        };
    },
    methods: {
        createFile(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.attachmentFile = result
                            if (this.form.attachmentFile) {
                                this.imageBlob = URL.createObjectURL(this.form.attachmentFile);
                            }
                        },
                    });

                }
                else {
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        selectFile() {
            this.$refs['fileInput'].click();
        },
        getDetailsTicket() {
            storeService.detailsTicket(this.storeId, this.ticketId).then(({ data }) => {
                this.details = data
                this.details.replies.push({
                    text: this.details.text,
                    id: 0,
                    fromSupport: false,
                    createdAt: this.details.createdAt,
                    attachmentFile: this.details.attachmentFile,
                })
                this.form.text = null;
                this.form.attachmentFile = null;
                this.imageBlob = null;
                this.loading = false;
            })
        },
        replyTicket() {
            this.loadingButton = true;
            let formData = new FormData();
            this.form.attachmentFile ? formData.append("attachmentFile", this.form.attachmentFile, this.form.attachmentFile.name) : null
            formData.append("text", this.form.text)
            storeService.replyTicket(this.storeId, this.ticketId, formData).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$bvModal.hide('create-ticket-id')
                this.getDetailsTicket()
            })
                .finally(() => {
                    this.loadingButton = false;
                });
        },
        closeTicket() {
            storeService.closeTicket(this.storeId, this.ticketId).then(({ data }) => {
                this.$router.push('/tickets')
            })
        }
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.ticketId = this.$route.query.id ? this.$route.query.id : 0;
        this.getDetailsTicket()
    },
};
</script>

<style lang="scss">
.upload-file {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='18' ry='18' stroke='%235E50EE95' stroke-width='4' stroke-dasharray='8%2c 16' stroke-dashoffset='15' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 18px;
    Width: 100%;
    height: 250px;
    margin: 0 0 0 0;
}

.ticket-img {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 16px;
    width: 250px;
    height: 250px;
}
</style>
